<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-12">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Document details</span>
            </h6>
        </div>
        <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="col-md-12 col-sm-12 ">
                <div class="col-md-12 col-sm-12 col-xs-12 b20-margin no-padding r20-padding l20-padding t30-padding b20-padding myG-box">
                    <div class="col-md-12 col-sm-12 col-xs-12 no-padding ">
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="documentURL">
                                <label for="floatingInputValueSubject">Document Url</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.fileName">
                                <label for="floatingInputValueSubject">Document file name</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <a style="color:blue; cursor:pointer" (click)="downloadFile()">Download Document</a>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.contentType">
                                <label for="floatingInputValueSubject">Document content type</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input type="text" disabled class="form-control" id="floatingInputValueSubject" [(ngModel)]="document.file.fileSize_mb">
                                <label for="floatingInputValueSubject">Document size (MB)</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectFolderOption($event)">

                                    <option *ngFor="let folder of folders" [value]="folder.id" [selected]="folder.selected">
                                        {{ folder.folderName}}
                                    </option>
                                </select>
                                <label for="floatingSelect">Folder</label>
                            </div>
                        </div>

                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectTypeOption($event)">

                                    <option *ngFor="let type of documentTypes" [value]="type.id" [selected]="type.selected">
                                        {{ type.type}}
                                    </option>
                                </select>
                                <label for="floatingSelect">Document type</label>
                            </div>
                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">

                            <div class="form-floating">
                                <textarea [(ngModel)]="document.file.description" style="height:150px" class="form-control" placeholder="describe the document here..." id="floatingTextareaDescription"></textarea>
                                <label for="floatingTextareaDescription">Document description</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="checkbox p-0">
                                <input [(ngModel)]="hasExpiryDate" id="checkbox1" type="checkbox">
                                <label class="text-muted" for="checkbox1">Set document expiry date</label>
                            </div>
                            <div *ngIf="hasExpiryDate" class="form-floating">
                                <input class="form-control digits" id="example-datetime-local-input"
                                       type="datetime-local" [(ngModel)]="expiryDate">
                                <label for="example-datetime-local-input">Select expiry date</label>
                            </div>
                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">

                            <h2>Share document to users</h2>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="">
                            <div class="col-md-12 col-sm-12 no-padding" style="padding-bottom:30px">
                                <div class="input-group">
                                    <input [(ngModel)]="newFollowerEmail" class="form-control" type="text" placeholder="type here user email address..." aria-label="email address">
                                    <div class="input-group-append">
                                        <!--<span class="input-group-text">add</span>-->
                                        <a class="input-group-text" *ngIf="!ccAddLoading" style=" height: 100%; color: green; cursor: pointer; " (click)="addFollower(newFollowerEmail)">
                                            <span class="fa fa-plus"></span>
                                        </a>
                                        <a class="input-group-text" *ngIf="ccAddLoading" style=" height: 100%; color: red; cursor: pointer;">
                                            <span class="fa fa-spinner"></span>
                                        </a>

                                    </div>
                                </div>
                            </div>



                            <div class="col-md-12" style="margin-top: 25px;">
                                <div class="row">
                                    <div class="col-md-4 col-sm-4" *ngFor="let item of document.usersAccess; let i = index">

                                        <div class="row" style="padding-bottom:15px">
                                            <div class="col-xl-2" style="padding:0px">
                                                <div class="postContactLogo default-bg" style="border-radius: 50%; background-size: cover; width: 40px; height: 40px" [ngStyle]="{'background-image': 'url(' + item.contactLogo + ')'}">
                                                </div>
                                            </div>
                                            <div class="col-xl-8">
                                                {{item.name}}<br />
                                                <small class="feed-time-date">
                                                    <span>{{item.email}}</span>
                                                </small><br />
                                                <small class="feed-time-date">
                                                    <span>{{item.organization}}</span>
                                                </small>
                                            </div>
                                            <div class="col-xl-2">
                                                <a *ngIf="!ccDeleteLoading" style="color:red;cursor:pointer; padding-left:5px" (click)="deleteFollower(item.filePermissionId ,i)">
                                                    <span class="fa fa-trash"></span>
                                                </a>
                                                <a *ngIf="ccDeleteLoading" style="color:red;cursor:pointer; padding-left:5px">
                                                    <span class="fa fa-spinner"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="document.usersAccess.length == 0">
                                    No emails found
                                </div>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding">
                            <button [disabled]="btnVerifyDisabled" style="margin-right:20px" (click)="deleteDocument()" class="btn mygistec-main-btn">Delete</button>
                            <button [disabled]="btnVerifyDisabled" style="margin-right:20px" (click)="update()" class="btn mygistec-main-btn">{{btnVerifyText}}</button>

                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>
</div>
